import MainVolunteerMatch from "../../components/volunteer-match-comp/main-volunteer-matching";

function VolunteerMatching() {
  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
      <MainVolunteerMatch/>
    </div>
  );
}

export default VolunteerMatching;


